const forgotPasswordActivate = {
  toastr: 'Password changed',
  toastr1: 'Password has been changed successfully'
};

export default forgotPasswordActivate;
